// extracted by mini-css-extract-plugin
export default {"heading":"views_heading__Cq2Ll","black":"views_black__gPCZS","white":"views_white__fVaOc","page_button":"views_page_button__D7ngf","invert_button":"views_invert_button__bqLGK"};